import { ContextMenuItemState } from "../ContextMenuItemState";

export class BaseFillMenuItemState extends ContextMenuItemState {
  public warnings = {
    show: false,
    warning_count: 0,
    tolerance_count: 0,
    transfer: {
      display: false,
      ids: new Array<string>(),
      orderRefs: new Array<string>(),
    },
    expired: {
      display: false,
      ids: new Array<string>(),
      orderRefs: new Array<string>(),
    },
    external: {
      display: false,
      ids: new Array<string>(),
      orderRefs: new Array<string>(),
    },
    credit_check: {
      display: false,
      ids: new Array<string>(),
      orderRefs: new Array<string>(),
    },
    fill: {
      display: false,
      ids: new Array<string>(),
      orderRefs: new Array<string>(),
    },
  };

  public relatedOrders: any = {};

  /*
        note unusual default values are used to assit breaking early
    */
  constructor(
    count: number = -1,
    itemIndex: number = 0,
    available: boolean = false,
    enabled: boolean = true,
    title: string = "",
    public checkFillCount: boolean = true,
  ) {
    super(count, itemIndex, available, enabled, title);
  }
}
